/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";

export enum Exterior {
  UnknownExterior = "UnknownExterior",
  BalconyTerrace = "BalconyTerrace",
  PrivateGarden = "PrivateGarden",
  BalconyTerraceAndPrivateGarden = "BalconyTerraceAndPrivateGarden",
}

export function exteriorFromJSON(object: any): Exterior {
  switch (object) {
    case 0:
    case "UnknownExterior":
      return Exterior.UnknownExterior;
    case 1:
    case "BalconyTerrace":
      return Exterior.BalconyTerrace;
    case 2:
    case "PrivateGarden":
      return Exterior.PrivateGarden;
    case 3:
    case "BalconyTerraceAndPrivateGarden":
      return Exterior.BalconyTerraceAndPrivateGarden;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum Exterior"
      );
  }
}

export function exteriorToJSON(object: Exterior): string {
  switch (object) {
    case Exterior.UnknownExterior:
      return "UnknownExterior";
    case Exterior.BalconyTerrace:
      return "BalconyTerrace";
    case Exterior.PrivateGarden:
      return "PrivateGarden";
    case Exterior.BalconyTerraceAndPrivateGarden:
      return "BalconyTerraceAndPrivateGarden";
    default:
      return "UNKNOWN";
  }
}

export function exteriorToNumber(object: Exterior): number {
  switch (object) {
    case Exterior.UnknownExterior:
      return 0;
    case Exterior.BalconyTerrace:
      return 1;
    case Exterior.PrivateGarden:
      return 2;
    case Exterior.BalconyTerraceAndPrivateGarden:
      return 3;
    default:
      return 0;
  }
}

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}
